import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Badge } from '../../../components/ui/Badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/Select';
import { 
  FileText, 
  Plus, 
  Edit, 
  Trash2, 
  Play, 
  Pause, 
  BarChart3,
  Filter,
  Search,
  ArrowUp,
  ArrowDown,
  Target,
  Clock,
  AlertTriangle,
  CheckCircle,
  Users,
  RefreshCw,
  Download,
  Upload,
  Settings,
  Zap,
  RotateCcw,
  Eye,
  EyeOff,
  Copy,
  ExternalLink,
  TrendingUp,
  TrendingDown,
  Star,
  Crown,
  Shield,
  Activity,
  UserCheck,
  Timer,
  Brain,
  Route,
  Lightning,
  Cpu,
  Database,
  Monitor,
  UserPlus,
  UserMinus,
  Calendar,
  Mail,
  Phone,
  Send,
  Archive,
  Unarchive,
  History,
  AlertCircle,
  Info,
  HelpCircle,
  XCircle,
  CheckCircle2,
  Clock3,
  CalendarDays,
  UserX,
  UserCog,
  UserSearch,
  UserEdit,
  Globe,
  Link,
  Key,
  Lock,
  Unlock,
  TestTube,
  Bug,
  Wifi,
  WifiOff,
  Server,
  Cloud,
  CloudOff,
  Terminal,
  Code,
  Hash,
  Layers,
  Box,
  Package,
  Archive as ArchiveIcon,
  File,
  Folder,
  FolderOpen,
  FileCode,
  FileJson,
  FileText as FileTextIcon,
  FileImage,
  FileVideo,
  FileAudio,
  FileSpreadsheet,
  FilePdf,
  FileZip,
  FileCheck,
  FileX,
  FilePlus,
  FileMinus,
  FileEdit,
  FileSearch,
  FileSlash,
  FileWarning,
  FileQuestion,
  FileHeart,
  FileClock,
  FileUp,
  FileDown,
  FileLeft,
  FileRight,
  FileBarChart,
  FilePieChart,
  FileLineChart,
  FileScissors,
  FileType,
  FileSymlink,
  FileStack,
  FileTree,
  FileBinary,
  FileCog,
  FileSettings,
  FileShield,
  FileLock,
  FileUnlock,
  FileKey,
  FileCertificate,
  FileSignature,
  FileVerified,
  FileBadge,
  FileTag,
  FileLabel,
  FileBookmark,
  FileStar,
  FileFlag,
  FileAlert,
  FileInfo,
  FileHelp,
  FileMessage,
  FileComment,
  FileChat,
  FileMail,
  FilePhone,
  FileVideo as FileVideoIcon,
  FileAudio as FileAudioIcon,
  FileImage as FileImageIcon,
  FileSpreadsheet as FileSpreadsheetIcon,
  FilePdf as FilePdfIcon,
  FileZip as FileZipIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  FilePlus as FilePlusIcon,
  FileMinus as FileMinusIcon,
  FileEdit as FileEditIcon,
  FileSearch as FileSearchIcon,
  FileSlash as FileSlashIcon,
  FileWarning as FileWarningIcon,
  FileQuestion as FileQuestionIcon,
  FileHeart as FileHeartIcon,
  FileClock as FileClockIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileLeft as FileLeftIcon,
  FileRight as FileRightIcon,
  FileBarChart as FileBarChartIcon,
  FilePieChart as FilePieChartIcon,
  FileLineChart as FileLineChartIcon,
  FileScissors as FileScissorsIcon,
  FileType as FileTypeIcon,
  FileSymlink as FileSymlinkIcon,
  FileStack as FileStackIcon,
  FileTree as FileTreeIcon,
  FileBinary as FileBinaryIcon,
  FileCog as FileCogIcon,
  FileSettings as FileSettingsIcon,
  FileShield as FileShieldIcon,
  FileLock as FileLockIcon,
  FileUnlock as FileUnlockIcon,
  FileKey as FileKeyIcon,
  FileCertificate as FileCertificateIcon,
  FileSignature as FileSignatureIcon,
  FileVerified as FileVerifiedIcon,
  FileBadge as FileBadgeIcon,
  FileTag as FileTagIcon,
  FileLabel as FileLabelIcon,
  FileBookmark as FileBookmarkIcon,
  FileStar as FileStarIcon,
  FileFlag as FileFlagIcon,
  FileAlert as FileAlertIcon,
  FileInfo as FileInfoIcon,
  FileHelp as FileHelpIcon,
  FileMessage as FileMessageIcon,
  FileComment as FileCommentIcon,
  FileChat as FileChatIcon,
  FileMail as FileMailIcon,
  FilePhone as FilePhoneIcon,
  DollarSign
} from 'lucide-react';
import { useDataContext } from '../../../contexts/DataContext';

const InvoiceManagement = () => {
  const { getMockData, updateMockData } = useDataContext();
  const [invoices, setInvoices] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [isGeneratingInvoice, setIsGeneratingInvoice] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCustomer, setFilterCustomer] = useState('all');

  useEffect(() => {
    loadInvoiceData();
  }, []);

  const loadInvoiceData = async () => {
    try {
      const data = getMockData('invoices');
      const customersData = getMockData('customers');
      
      setInvoices(data?.invoices || []);
      setCustomers(customersData?.customers || []);
    } catch (error) {
      console.error('Failed to load invoice data:', error);
    }
  };

  const handleGenerateInvoice = () => {
    setIsGeneratingInvoice(true);
  };

  const handleEditInvoice = (invoice) => {
    setEditingInvoice(invoice);
  };

  const handleSendInvoice = (invoiceId) => {
    if (window.confirm('Are you sure you want to send this invoice to the customer?')) {
      alert(`Sending invoice ${invoiceId}...`);
    }
  };

  const handleMarkPaid = (invoiceId) => {
    if (window.confirm('Are you sure you want to mark this invoice as paid?')) {
      alert(`Marking invoice ${invoiceId} as paid...`);
    }
  };

  const handleDeleteInvoice = (invoiceId) => {
    if (window.confirm('Are you sure you want to delete this invoice?')) {
      alert(`Deleting invoice ${invoiceId}...`);
    }
  };

  const handleExportInvoice = (invoiceId) => {
    alert(`Exporting invoice ${invoiceId}...`);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'paid': return 'green';
      case 'sent': return 'blue';
      case 'draft': return 'gray';
      case 'overdue': return 'red';
      case 'cancelled': return 'red';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'paid': return CheckCircle;
      case 'sent': return Send;
      case 'draft': return Edit;
      case 'overdue': return AlertTriangle;
      case 'cancelled': return XCircle;
      default: return AlertTriangle;
    }
  };

  const filteredInvoices = invoices.filter(invoice => {
    const matchesSearch = invoice.invoiceNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         invoice.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         invoice.customerEmail.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || invoice.status === filterStatus;
    const matchesCustomer = filterCustomer === 'all' || invoice.customerId === filterCustomer;
    return matchesSearch && matchesStatus && matchesCustomer;
  });

  const mockInvoices = [
    {
      id: 1,
      invoiceNumber: "INV-2025-001",
      customerId: "cust-1",
      customerName: "Acme Corporation",
      customerEmail: "billing@acme.com",
      status: "paid",
      amount: 999.00,
      currency: "USD",
      dueDate: "2025-01-15T00:00:00Z",
      paidDate: "2025-01-14T16:30:00Z",
      sentDate: "2025-01-01T10:00:00Z",
      createdAt: "2025-01-01T09:00:00Z",
      createdBy: "Sarah Johnson",
      items: [
        { description: "Enterprise Plan - Annual Subscription", quantity: 1, unitPrice: 999.00, total: 999.00 }
      ],
      subtotal: 999.00,
      tax: 0.00,
      total: 999.00,
      notes: "Annual subscription for Enterprise plan"
    },
    {
      id: 2,
      invoiceNumber: "INV-2025-002",
      customerId: "cust-2",
      customerName: "TechStart Inc",
      customerEmail: "finance@techstart.com",
      status: "sent",
      amount: 299.00,
      currency: "USD",
      dueDate: "2025-01-20T00:00:00Z",
      paidDate: null,
      sentDate: "2025-01-10T14:30:00Z",
      createdAt: "2025-01-10T14:00:00Z",
      createdBy: "David Wilson",
      items: [
        { description: "Professional Plan - Monthly Subscription", quantity: 1, unitPrice: 299.00, total: 299.00 }
      ],
      subtotal: 299.00,
      tax: 0.00,
      total: 299.00,
      notes: "Monthly subscription for Professional plan"
    },
    {
      id: 3,
      invoiceNumber: "INV-2025-003",
      customerId: "cust-3",
      customerName: "Global Solutions Ltd",
      customerEmail: "accounts@globalsolutions.com",
      status: "overdue",
      amount: 1499.00,
      currency: "USD",
      dueDate: "2025-01-05T00:00:00Z",
      paidDate: null,
      sentDate: "2024-12-20T11:00:00Z",
      createdAt: "2024-12-20T10:30:00Z",
      createdBy: "Mike Chen",
      items: [
        { description: "Enterprise Plan - Annual Subscription", quantity: 1, unitPrice: 1499.00, total: 1499.00 }
      ],
      subtotal: 1499.00,
      tax: 0.00,
      total: 1499.00,
      notes: "Annual subscription for Enterprise plan"
    },
    {
      id: 4,
      invoiceNumber: "INV-2025-004",
      customerId: "cust-4",
      customerName: "StartupXYZ",
      customerEmail: "billing@startupxyz.com",
      status: "draft",
      amount: 99.00,
      currency: "USD",
      dueDate: "2025-01-25T00:00:00Z",
      paidDate: null,
      sentDate: null,
      createdAt: "2025-01-15T16:00:00Z",
      createdBy: "Lisa Park",
      items: [
        { description: "Basic Plan - Monthly Subscription", quantity: 1, unitPrice: 99.00, total: 99.00 }
      ],
      subtotal: 99.00,
      tax: 0.00,
      total: 99.00,
      notes: "Monthly subscription for Basic plan"
    },
    {
      id: 5,
      invoiceNumber: "INV-2025-005",
      customerId: "cust-5",
      customerName: "Enterprise Corp",
      customerEmail: "finance@enterprise.com",
      status: "cancelled",
      amount: 2499.00,
      currency: "USD",
      dueDate: "2025-01-10T00:00:00Z",
      paidDate: null,
      sentDate: "2025-01-05T09:00:00Z",
      createdAt: "2025-01-05T08:30:00Z",
      createdBy: "John Smith",
      items: [
        { description: "Enterprise Plus Plan - Annual Subscription", quantity: 1, unitPrice: 2499.00, total: 2499.00 }
      ],
      subtotal: 2499.00,
      tax: 0.00,
      total: 2499.00,
      notes: "Cancelled due to customer request"
    }
  ];

  const invoiceMetrics = [
    {
      title: 'Total Invoices',
      value: invoices.length,
      icon: FileText,
      color: 'blue',
      trend: '+2',
      trendDirection: 'up'
    },
    {
      title: 'Paid Invoices',
      value: invoices.filter(i => i.status === 'paid').length,
      icon: CheckCircle,
      color: 'green',
      trend: '+1',
      trendDirection: 'up'
    },
    {
      title: 'Outstanding Amount',
      value: '$1,897.00',
      icon: DollarSign,
      color: 'yellow',
      trend: '+$299.00',
      trendDirection: 'up'
    },
    {
      title: 'Overdue Invoices',
      value: invoices.filter(i => i.status === 'overdue').length,
      icon: AlertTriangle,
      color: 'red',
      trend: '+1',
      trendDirection: 'up'
    }
  ];

  const recentActivity = [
    {
      id: 1,
      action: "invoice_paid",
      invoiceNumber: "INV-2025-001",
      customerName: "Acme Corporation",
      amount: "$999.00",
      timestamp: "2025-01-14T16:30:00Z",
      user: "Sarah Johnson"
    },
    {
      id: 2,
      action: "invoice_sent",
      invoiceNumber: "INV-2025-002",
      customerName: "TechStart Inc",
      amount: "$299.00",
      timestamp: "2025-01-10T14:30:00Z",
      user: "David Wilson"
    },
    {
      id: 3,
      action: "invoice_created",
      invoiceNumber: "INV-2025-004",
      customerName: "StartupXYZ",
      amount: "$99.00",
      timestamp: "2025-01-15T16:00:00Z",
      user: "Lisa Park"
    }
  ];

  return (
    <div className="invoice-management p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Invoice Management</h1>
            <p className="text-gray-600">Generate and manage invoices for subscriptions</p>
          </div>
          <div className="flex items-center space-x-4">
            <Button onClick={handleGenerateInvoice}>
              <Plus className="h-4 w-4 mr-2" />
              Generate Invoice
            </Button>
            <Button variant="outline">
              <BarChart3 className="h-4 w-4 mr-2" />
              Analytics
            </Button>
          </div>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {invoiceMetrics.map((metric, index) => {
          const Icon = metric.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">{metric.title}</CardTitle>
                <Icon className={`h-4 w-4 text-${metric.color}-500`} />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold text-gray-900">{metric.value}</div>
                <div className={`flex items-center text-xs ${
                  metric.trendDirection === 'up' ? 'text-green-600' : 'text-red-600'
                }`}>
                  <ArrowUp className="h-3 w-3 mr-1" />
                  {metric.trend} from last week
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Recent Activity */}
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Activity className="h-5 w-5 mr-2" />
            Recent Invoice Activity
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {recentActivity.map((activity) => (
              <div key={activity.id} className="flex items-center justify-between p-3 border rounded-lg">
                <div className="flex items-center space-x-3">
                  <Badge variant={activity.action === 'invoice_paid' ? 'default' : 'secondary'}>
                    {activity.action.replace('_', ' ')}
                  </Badge>
                  <div>
                    <div className="font-medium">{activity.invoiceNumber} - {activity.customerName}</div>
                    <div className="text-sm text-gray-600">Amount: {activity.amount}</div>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-600">
                  <div>{activity.user}</div>
                  <div>{new Date(activity.timestamp).toLocaleString()}</div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Filters and Search */}
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Filter className="h-5 w-5 mr-2" />
            Filter Invoices
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center space-x-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  placeholder="Search invoices..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>
            <Select value={filterStatus} onValueChange={setFilterStatus}>
              <SelectTrigger className="w-48">
                <SelectValue placeholder="Filter by status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Status</SelectItem>
                <SelectItem value="draft">Draft</SelectItem>
                <SelectItem value="sent">Sent</SelectItem>
                <SelectItem value="paid">Paid</SelectItem>
                <SelectItem value="overdue">Overdue</SelectItem>
                <SelectItem value="cancelled">Cancelled</SelectItem>
              </SelectContent>
            </Select>
            <Select value={filterCustomer} onValueChange={setFilterCustomer}>
              <SelectTrigger className="w-48">
                <SelectValue placeholder="Filter by customer" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Customers</SelectItem>
                <SelectItem value="cust-1">Acme Corporation</SelectItem>
                <SelectItem value="cust-2">TechStart Inc</SelectItem>
                <SelectItem value="cust-3">Global Solutions Ltd</SelectItem>
                <SelectItem value="cust-4">StartupXYZ</SelectItem>
                <SelectItem value="cust-5">Enterprise Corp</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {/* Invoices List */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <FileText className="h-5 w-5 mr-2" />
            Invoices ({mockInvoices.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {mockInvoices.map((invoice) => {
              const StatusIcon = getStatusIcon(invoice.status);
              return (
                <div key={invoice.id} className="p-6 border rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h3 className="text-lg font-semibold">{invoice.invoiceNumber}</h3>
                        <Badge variant={invoice.status === 'paid' ? 'default' : 'secondary'}>
                          <StatusIcon className="h-3 w-3 mr-1" />
                          {invoice.status}
                        </Badge>
                        <Badge variant="outline">{invoice.currency}</Badge>
                      </div>
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Customer Details:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Customer:</span> {invoice.customerName}
                          </div>
                          <div>
                            <span className="font-medium">Email:</span> {invoice.customerEmail}
                          </div>
                          <div>
                            <span className="font-medium">Amount:</span> ${invoice.amount.toFixed(2)}
                          </div>
                        </div>
                      </div>

                      {/* Invoice Items */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Invoice Items:</h4>
                        <div className="space-y-2">
                          {invoice.items.map((item, index) => (
                            <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded">
                              <div>
                                <div className="font-medium">{item.description}</div>
                                <div className="text-sm text-gray-600">Qty: {item.quantity} × ${item.unitPrice.toFixed(2)}</div>
                              </div>
                              <div className="font-medium">${item.total.toFixed(2)}</div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Invoice Summary */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Invoice Summary:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Subtotal:</span> ${invoice.subtotal.toFixed(2)}
                          </div>
                          <div>
                            <span className="font-medium">Tax:</span> ${invoice.tax.toFixed(2)}
                          </div>
                          <div>
                            <span className="font-medium">Total:</span> ${invoice.total.toFixed(2)}
                          </div>
                          <div>
                            <span className="font-medium">Due Date:</span> {new Date(invoice.dueDate).toLocaleDateString()}
                          </div>
                        </div>
                      </div>

                      {/* Timestamps */}
                      <div className="flex items-center space-x-6 text-sm text-gray-600">
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1" />
                          <span>Created: {new Date(invoice.createdAt).toLocaleString()}</span>
                        </div>
                        <div className="flex items-center">
                          <UserCheck className="h-4 w-4 mr-1" />
                          <span>Created By: {invoice.createdBy}</span>
                        </div>
                        {invoice.sentDate && (
                          <div className="flex items-center">
                            <Send className="h-4 w-4 mr-1" />
                            <span>Sent: {new Date(invoice.sentDate).toLocaleString()}</span>
                          </div>
                        )}
                        {invoice.paidDate && (
                          <div className="flex items-center">
                            <CheckCircle className="h-4 w-4 mr-1" />
                            <span>Paid: {new Date(invoice.paidDate).toLocaleString()}</span>
                          </div>
                        )}
                      </div>

                      {/* Notes */}
                      {invoice.notes && (
                        <div className="mt-3 p-3 bg-blue-50 rounded-lg">
                          <div className="text-sm font-medium text-blue-800">Notes:</div>
                          <div className="text-sm text-blue-700">{invoice.notes}</div>
                        </div>
                      )}
                    </div>

                    {/* Actions */}
                    <div className="flex items-center space-x-2 ml-4">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleExportInvoice(invoice.id)}
                      >
                        <Download className="h-3 w-3 mr-1" />
                        Export
                      </Button>
                      {invoice.status === 'draft' && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleSendInvoice(invoice.id)}
                        >
                          <Send className="h-3 w-3 mr-1" />
                          Send
                        </Button>
                      )}
                      {invoice.status === 'sent' && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleMarkPaid(invoice.id)}
                        >
                          <CheckCircle className="h-3 w-3 mr-1" />
                          Mark Paid
                        </Button>
                      )}
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleEditInvoice(invoice)}
                      >
                        <Edit className="h-3 w-3 mr-1" />
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleDeleteInvoice(invoice.id)}
                      >
                        <Trash2 className="h-3 w-3 mr-1" />
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Quick Actions */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Zap className="h-5 w-5 mr-2" />
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Button className="h-20 flex flex-col items-center justify-center space-y-2">
              <Plus className="h-6 w-6" />
              <span>Generate Invoice</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <Send className="h-6 w-6" />
              <span>Send All</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <Download className="h-6 w-6" />
              <span>Export All</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <Settings className="h-6 w-6" />
              <span>Invoice Settings</span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default InvoiceManagement;
